import { Factory, TrialPeriodLength } from '../..';

export enum TrialCreationBehaviorType {
  // OptIn = 'OptIn',
  AlwaysApply = 'AlwaysApply',
  RequiresCode = 'RequiresCode',
}

export class TrialCreationBehavior {
  type: TrialCreationBehaviorType;
  constructor(json: any) {
    this.type = json.type;
  }

  public static getFactory(): Factory<TrialCreationBehavior> {
    return new (class implements Factory<TrialCreationBehavior> {
      make(json: any): TrialCreationBehavior {
        switch (json.type) {
          // case TrialCreationBehaviorType.OptIn:
          //   return new TrialCreationBehaviorOptIn(json);
          case TrialCreationBehaviorType.AlwaysApply:
            return new TrialCreationBehaviorAlwaysApply(json);
          case TrialCreationBehaviorType.RequiresCode:
            return new TrialCreationBehaviorRequiresCode(json);
          default:
            throw new Error('Unrecognized TrialCreationBehavior type (' + json.type + ').');
        }
      }

      getTableName(): string {
        return 'TrialCreationBehavior are never stored in IndexedDB.';
      }
    })();
  }
}

// export class TrialCreationBehaviorOptIn extends TrialCreationBehavior {
//   periodLength: TrialPeriodLength;
//   constructor(json: any) {
//     super(json);
//     this.periodLength = json.periodLength;
//   }
// }

export class TrialCreationBehaviorAlwaysApply extends TrialCreationBehavior {
  periodLength: TrialPeriodLength;
  constructor(json: any) {
    super(json);
    this.periodLength = json.periodLength;
  }
}

export class TrialCreationBehaviorRequiresCode extends TrialCreationBehavior {
  constructor(json: any) {
    super(json);
  }
}
